(function(window, angular, undefined) {
    angular.module('formApp')
    .directive('numbersOnly', [function() {
        return {
            restrict: 'A',
            link: function(scope, elem, attrs) {

                var re = new RegExp(attrs.restrictTo);
                // [Backspace,Tab,Enter,Ctrl,PageUp,PageDown,ArrowLeft,ArrowUp,ArrowRight,ArrowDown,Delete]
                var exclude = [8,9,13,16,17,34,34,38,37,39,46];
                
                elem[0].addEventListener('keydown', function(event) {
                    // keyCode numbers on top of keyboard ( 0 - 9 ) : 48 - 57, numbers on numeric keypad ( 0 - 9 ) : 96 - 105
                    if (exclude.indexOf(event.keyCode) === -1 && !((event.keyCode >= 48 && event.keyCode <=57) || (event.keyCode >= 96 && event.keyCode <=105))) {
                        event.preventDefault();
                    }
                    if(event.shiftKey){
                        event.preventDefault(); 
                    }
                });
            }
        };
    }]);
})(window, window.angular);